import { getCitationSourceForLookup } from "@/utils/citation-utils"

export type CitationType = "web" | "library" | "file" | "m365" | "extraction"

export const getCitationType = (citation: string): CitationType => {
  const cleanCitation = getCitationSourceForLookup(citation)

  if (cleanCitation.startsWith("http://") || cleanCitation.startsWith("https://")) {
    return "web"
  }

  if (cleanCitation.includes(":")) {
    const libraryId = cleanCitation.split(":")[0]
    if (libraryId === "req") {
      return "extraction"
    }
    if (libraryId === "localdocs") {
      return "file"
    }
    if (libraryId === "doc") {
      return "file"
    }
    if (libraryId === "m365") {
      return "m365"
    }
    return "library"
  }

  return "file"
}
